import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.279 287.791m-223.922 0a223.922 223.922 0 1 0 447.844 0 223.922 223.922 0 1 0-447.844 0Z\" p-id=\"3078\" /><path d=\"M512.279 511.713c-219.028 0-398.507 182.354-414.671 413.777-1.288 18.442 13.449 34.068 31.935 34.068h765.471c18.487 0 33.223-15.627 31.935-34.068-16.164-231.422-195.643-413.777-414.67-413.777z\" p-id=\"3079\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol